import React from 'react';
import { Layout, SEO } from '../components';
import styled from 'styled-components';

const Policies = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  @media (max-width: 834px) {
    width: 90%;
  }
`;

export default function PoliciesPage() {
  return (
    <Layout>
      <SEO
        title="Policies Page"
        description="Privacy Policies for Each and Every Girl"
      />
      <Policies>
        <h2 id="Privacy Policy">Privacy Policy</h2>
        <p>  </p>
        <p>Effective date: 02/05/2021 </p>
        <p>  </p>
        <p>
          <strong>1</strong> <strong>_Introduction_</strong> 
        </p>
        <p> </p>
        <p>
          Welcome to <strong>Each and Every Girl, LLC</strong>. 
        </p>
        <p>  </p>
        <p>
          Each and Every Girl, LLC (“us”, “we”, or “our”) operates https:
          <a href="http://eachandeverygirl.com">eachandeverygirl.com</a>
           (hereinafter referred to as “<strong>Service</strong>”). 
        </p>
        <p>  </p>
        <p>
          Our Privacy Policy governs your visit to https:
          <a href="http://eachandeverygirl.com">eachandeverygirl.com</a>, and
          explains how we collect, safeguard and disclose information that
          results from your use of our Service.  
        </p>
        <p>  </p>
        <p>
          We use your data to provide and improve Service. By using Service, you
          agree to the collection and use of information in accordance with this
          policy. Unless otherwise defined in this Privacy Policy, the terms
          used in this Privacy Policy have the same meanings as in our Terms and
          Conditions. 
        </p>
        <p>  </p>
        <p>
          Our Terms and Conditions (“<strong>Terms</strong>”) govern all use of
          our Service and together with the Privacy Policy constitutes your
          agreement with us (“<strong>agreement</strong>”). 
        </p>
        <p>  </p>
        <p>
          <strong>2</strong> <strong>_Definitions_</strong> 
        </p>
        <p> </p>
        <p>
          <strong>SERVICE</strong>means the https:
          <a href="http://eachandeverygirl.com">eachandeverygirl.com</a>{' '}
          website operated by Each and Every Girl, LLC. 
        </p>
        <p>  </p>
        <p>
          <strong>PERSONAL DATA</strong> means data about a living individual
          who can be identified from those data (or from those and other
          information either in our possession or likely to come into our
          possession). 
        </p>
        <p>  </p>
        <p>
          <strong>USAGE DATA</strong> is data collected automatically either
          generated by the use of Service or from Service infrastructure itself
          (for example, the duration of a page visit). 
        </p>
        <p>  </p>
        <p>
          <strong>COOKIES</strong> are small files stored on your device
          (computer or mobile device). 
        </p>
        <p>  </p>
        <p>
          <strong>DATA CONTROLLER</strong> means a natural or legal person who
          (either alone or jointly or in common with other persons) determines
          the purposes for which and the manner in which any personal data are,
          or are to be, processed. For the purpose of this Privacy Policy, we
          are a Data Controller of your data. 
        </p>
        <p>  </p>
        <p>
          <strong>DATA PROCESSORS (OR SERVICE PROVIDERS)</strong> means any
          natural or legal person who processes the data on behalf of the Data
          Controller. We may use the services of various Service Providers in
          order to process your data more effectively. 
        </p>
        <p>  </p>
        <p>
          <strong>DATA SUBJECT</strong>is any living individual who is the
          subject of Personal Data. 
        </p>
        <p>  </p>
        <p>
          <strong>THE USER</strong>is the individual using our Service. The User
          corresponds to the Data Subject, who is the subject of Personal Data. 
        </p>
        <p>  </p>
        <p>
          <strong>3</strong> <strong>_Information Collection and Use_</strong> 
        </p>
        <p> </p>
        <p>
          We collect several different types of information for various purposes
          to provide and improve our Service to you. 
        </p>
        <p>  </p>
        <p>
          <strong>4</strong> <strong>_Types of Data Collected_</strong> 
        </p>
        <p> </p>
        <p>
          <strong>Personal Data</strong> 
        </p>
        <p>
          While using our Service, we may ask you to provide us with certain
          personally identifiable information that can be used to contact or
          identify you (“<strong>Personal Data</strong>”). Personally
          identifiable information may include, but is not limited to: 
        </p>
        <p>  </p>
        <ul>
          <li>Email address </li>
        </ul>
        <p>  </p>
        <ul>
          <li>First name and last name </li>
        </ul>
        <p>  </p>
        <ul>
          <li>Cookies and Usage Data </li>
        </ul>
        <p>  </p>
        <p>
          <strong>Usage Data</strong> 
        </p>
        <p>
          We may also collect information that your browser sends whenever you
          visit our Service or when you access Service by or through a mobile
          device (“<strong>Usage Data</strong>”). 
        </p>
        <p>  </p>
        <p>
          This Usage Data may include information such as your computer’s
          Internet Protocol address (e.g. IP address), browser type, browser
          version, the pages of our Service that you visit, the time and date of
          your visit, the time spent on those pages, unique device identifiers
          and other diagnostic data. 
        </p>
        <p>  </p>
        <p>
          When you access Service with a mobile device, this Usage Data may
          include information such as the type of mobile device you use, your
          mobile device unique ID, the IP address of your mobile device, your
          mobile operating system, the type of mobile Internet browser you use,
          unique device identifiers and other diagnostic data. 
        </p>
        <p>  </p>
        <p>
          <strong>Location Data</strong> 
        </p>
        <p>
          We may use and store information about your location if you give us
          permission to do so (“<strong>Location Data</strong>”). We use this
          data to provide features of our Service, to improve and customize our
          Service. 
        </p>
        <p>  </p>
        <p>
          You can enable or disable location services when you use our Service
          at any time by way of your device settings. 
        </p>
        <p>  </p>
        <p>
          <strong>Tracking Cookies Data</strong> 
        </p>
        <p>
          We use cookies and similar tracking technologies to track the activity
          on our Service and we hold certain information. 
        </p>
        <p>  </p>
        <p>
          Cookies are files with a small amount of data which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          website and stored on your device. Other tracking technologies are
          also used such as beacons, tags and scripts to collect and track
          information and to improve and analyze our Service. 
        </p>
        <p>  </p>
        <p>
          You can instruct your browser to refuse all cookies or to indicate
          when a cookie is being sent. However, if you do not accept cookies,
          you may not be able to use some portions of our Service. 
        </p>
        <p>  </p>
        <p>Examples of Cookies we use: </p>
        <p>  </p>
        <ul>
          <li>
            <strong>Session Cookies:</strong> We use Session Cookies to operate
            our Service. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            <strong>Preference Cookies:</strong> We use Preference Cookies to
            remember your preferences and various settings. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            <strong>Security Cookies:</strong> We use Security Cookies for
            security purposes. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            <strong>Advertising Cookies:</strong> Advertising Cookies are used
            to serve you with advertisements that may be relevant to you and
            your interests. 
          </li>
        </ul>
        <p>  </p>
        <p>
          <strong>Other Data</strong> 
        </p>
        <p>
          While using our Service, we may also collect the following
          information: sex, age, date of birth, place of birth, passport
          details, citizenship, registration at place of residence and actual
          address, telephone number (work, mobile), details of documents on
          education, qualification, professional training, employment
          agreements, non-disclosure agreements, information on bonuses and
          compensation, information on marital status, family members, social
          security (or other taxpayer identification) number, office location
          and other data.  
        </p>
        <p>  </p>
        <p>
          <strong>5</strong> <strong>_Use of Data_</strong> 
        </p>
        <p> </p>
        <p>
          Each and Every Girl, LLC uses the collected data for various
          purposes: 
        </p>
        <p>  </p>
        <ul>
          <li>to provide and maintain our Service; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to notify you about changes to our Service;  </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            to allow you to participate in interactive features of our Service
            when you choose to do so;  
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to provide customer support;  </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            to gather analysis or valuable information so that we can improve
            our Service;  
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to monitor the usage of our Service; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to detect, prevent and address technical issues; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to fulfill any other purpose for which you provide it; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            to carry out our obligations and enforce our rights arising from any
            contracts entered into between you and us, including for billing and
            collection; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            to provide you with notices about your account and/or subscription,
            including expiration and renewal notices, email-instructions, etc.; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            to provide you with news, special offers and general information
            about other goods, services and events which we offer that are
            similar to those that you have already purchased or enquired about
            unless you have opted not to receive such information; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            in any other way we may describe when you provide the information; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>for any other purpose with your consent.  </li>
        </ul>
        <p>  </p>
        <p>
          <strong>6</strong> <strong>_Retention of Data_</strong> 
        </p>
        <p> </p>
        <p>
          We will retain your Personal Data only for as long as is necessary for
          the purposes set out in this Privacy Policy. We will retain and use
          your Personal Data to the extent necessary to comply with our legal
          obligations (for example, if we are required to retain your data to
          comply with applicable laws), resolve disputes, and enforce our legal
          agreements and policies. 
        </p>
        <p>  </p>
        <p>
          We will also retain Usage Data for internal analysis purposes. Usage
          Data is generally retained for a shorter period, except when this data
          is used to strengthen the security or to improve the functionality of
          our Service, or we are legally obligated to retain this data for
          longer time periods. 
        </p>
        <p>  </p>
        <p>
          <strong>7</strong> <strong>_Transfer of Data_</strong> 
        </p>
        <p> </p>
        <p>
          Your information, including Personal Data, may be transferred to – and
          maintained on – computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction. 
        </p>
        <p>  </p>
        <p>
          If you are located outside United States and choose to provide
          information to us, please note that we transfer the data, including
          Personal Data, to United States and process it there. 
        </p>
        <p>  </p>
        <p>
          Your consent to this Privacy Policy followed by your submission of
          such information represents your agreement to that transfer. 
        </p>
        <p>  </p>
        <p>
          Each and Every Girl, LLC will take all the steps reasonably necessary
          to ensure that your data is treated securely and in accordance with
          this Privacy Policy and no transfer of your Personal Data will take
          place to an organisation or a country unless there are adequate
          controls in place including the security of your data and other
          personal information. 
        </p>
        <p>  </p>
        <p>
          <strong>8</strong> <strong>_Disclosure of Data_</strong> 
        </p>
        <p> </p>
        <p>
          We may disclose personal information that we collect, or you provide: 
        </p>
        <p>  </p>
        <ul>
          <li>
            <strong>Disclosure for Law Enforcement.</strong> 
          </li>
        </ul>
        <p>
          Under certain circumstances, we may be required to disclose your
          Personal Data if required to do so by law or in response to valid
          requests by public authorities. 
        </p>
        <p>  </p>
        <ul>
          <li>
            <strong>Business Transaction.</strong> 
          </li>
        </ul>
        <p>
          If we or our subsidiaries are involved in a merger, acquisition or
          asset sale, your Personal Data may be transferred. 
        </p>
        <p>  </p>
        <ul>
          <li>
            <strong>Other cases. We may disclose your information also:</strong>
             
          </li>
        </ul>
        <p> </p>
        <ul>
          <li>to our subsidiaries and affiliates; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>to fulfill the purpose for which you provide it; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            if we believe disclosure is necessary or appropriate to protect the
            rights, property, or safety of the Company, our customers, or
            others. 
          </li>
        </ul>
        <p>  </p>
        <p>
          <strong>9</strong> <strong>_Security of Data_</strong> 
        </p>
        <p> </p>
        <p>
          The security of your data is important to us but remember that no
          method of transmission over the Internet or method of electronic
          storage is 100% secure. While we strive to use commercially acceptable
          means to protect your Personal Data, we cannot guarantee its absolute
          security. 
        </p>
        <p>  </p>
        <p>
          <strong>10</strong>{' '}
          <strong>
            _Your Data Protection Rights Under General Data Protection
            Regulation (GDPR)_
          </strong>
           
        </p>
        <p> </p>
        <p>
          If you are a resident of the European Union (EU) and European Economic
          Area (EEA), you have certain data protection rights, covered by GDPR.
          – See more at{' '}
          <a href="https://eur-lex.europa.eu/eli/reg/2016/679/oj">
            https://eur-lex.europa.eu/eli/reg/2016/679/oj
          </a>
            
        </p>
        <p>  </p>
        <p>
          We aim to take reasonable steps to allow you to correct, amend,
          delete, or limit the use of your Personal Data. 
        </p>
        <p>  </p>
        <p>
          If you wish to be informed what Personal Data we hold about you and if
          you want it to be removed from our systems, please email us at{' '}
          <a href="mailto:eachandeverygirl@gmail.com">
            eachandeverygirl@gmail.com
          </a>
          .  
        </p>
        <p>  </p>
        <p>
          In certain circumstances, you have the following data protection
          rights: 
        </p>
        <p>  </p>
        <ul>
          <li>
            the right to access, update or to delete the information we have on
            you; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            the right of rectification. You have the right to have your
            information rectified if that information is inaccurate or
            incomplete; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            the right to object. You have the right to object to our processing
            of your Personal Data; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            the right of restriction. You have the right to request that we
            restrict the processing of your personal information; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            the right to data portability. You have the right to be provided
            with a copy of your Personal Data in a structured, machine-readable
            and commonly used format; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            the right to withdraw consent. You also have the right to withdraw
            your consent at any time where we rely on your consent to process
            your personal information; 
          </li>
        </ul>
        <p>  </p>
        <p>
          Please note that we may ask you to verify your identity before
          responding to such requests. Please note, we may not able to provide
          Service without some necessary data. 
        </p>
        <p>  </p>
        <p>
          You have the right to complain to a Data Protection Authority about
          our collection and use of your Personal Data. For more information,
          please contact your local data protection authority in the European
          Economic Area (EEA). 
        </p>
        <p>  </p>
        <p>
          <strong>11</strong>{' '}
          <strong>
            _Your Data Protection Rights under the California Privacy Protection
            Act (CalOPPA)_
          </strong>
           
        </p>
        <p> </p>
        <p>
          CalOPPA is the first state law in the nation to require commercial
          websites and online services to post a privacy policy. The law’s reach
          stretches well beyond California to require a person or company in the
          United States (and conceivable the world) that operates websites
          collecting personally identifiable information from California
          consumers to post a conspicuous privacy policy on its website stating
          exactly the information being collected and those individuals with
          whom it is being shared, and to comply with this policy. – See more
          at:{' '}
          <a href="https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/">
            https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/
          </a>{' '}
           
        </p>
        <p>  </p>
        <p>According to CalOPPA we agree to the following: </p>
        <p>  </p>
        <ul>
          <li>users can visit our site anonymously; </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            our Privacy Policy link includes the word “Privacy”, and can easily
            be found on the page specified above on the home page of our
            website; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            users will be notified of any privacy policy changes on our Privacy
            Policy Page; 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            users are able to change their personal information by emailing us
            at{' '}
            <a href="mailto:eachandeverygirl@gmail.com">
              eachandeverygirl@gmail.com
            </a>
            .  
          </li>
        </ul>
        <p>  </p>
        <p>Our Policy on “Do Not Track” Signals: </p>
        <p>  </p>
        <p>
          We honor Do Not Track signals and do not track, plant cookies, or use
          advertising when a Do Not Track browser mechanism is in place. Do Not
          Track is a preference you can set in your web browser to inform
          websites that you do not want to be tracked.  
        </p>
        <p>  </p>
        <p>
          You can enable or disable Do Not Track by visiting the Preferences or
          Settings page of your web browser. 
        </p>
        <p>  </p>
        <p>
          <strong>12</strong>{' '}
          <strong>
            _Your Data Protection Rights under the California Consumer Privacy
            Act (CCPA)_
          </strong>
           
        </p>
        <p> </p>
        <p>
          If you are a California resident, you are entitled to learn what data
          we collect about you, ask to delete your data and not to sell (share)
          it. To exercise your data protection rights, you can make certain
          requests and ask us: 
        </p>
        <p>  </p>
        <ul>
          <li>
            <strong>What personal information we have about you</strong>. If you
            make this request, we will return to you: 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            The categories of personal information we have collected about you. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            The categories of sources from which we collect your personal
            information. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            The business or commercial purpose for collecting or selling your
            personal information. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            The categories of third parties with whom we share personal
            information. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            The specific pieces of personal information we have collected about
            you. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            A list of categories of personal information that we have sold,
            along with the category of any other company we sold it to. If we
            have not sold your personal information, we will inform you of that
            fact. 
          </li>
        </ul>
        <p>  </p>
        <ul>
          <li>
            A list of categories of personal information that we have disclosed
            for a business purpose, along with the category of any other company
            we shared it with. 
          </li>
        </ul>
        <p>  </p>
        <p>
          Please note, you are entitled to ask us to provide you with this
          information up to two times in a rolling twelve-month period. When you
          make this request, the information provided may be limited to the
          personal information we collected about you in the previous
          12 months. 
        </p>
        <p>  </p>
        <ul>
          <li>
            <strong>To delete your personal information</strong>. If you make
            this request, we will delete the personal information we hold about
            you as of the date of your request from our records and direct any
            service providers to do the same. In some cases, deletion may be
            accomplished through de-identification of the information. If you
            choose to delete your personal information, you may not be able to
            use certain functions that require your personal information to
            operate. 
          </li>
        </ul>
        <p> </p>
        <ul>
          <li>
            <strong>To stop selling your personal information</strong>. We don’t
            sell or rent your personal information to any third parties for any
            purpose. You are the only owner of your Personal Data and can
            request disclosure or deletion at any time. 
          </li>
        </ul>
        <p>  </p>
        <p>
          Please note, if you ask us to delete or stop selling your data, it may
          impact your experience with us, and you may not be able to participate
          in certain programs or membership services which require the usage of
          your personal information to function. But in no circumstances, we
          will discriminate against you for exercising your rights. 
        </p>
        <p>  </p>
        <p>
          To exercise your California data protection rights described above,
          please send your request(s) by one of the following means: 
        </p>
        <p>  </p>
        <p>
          By email:{' '}
          <a href="mailto:eachandeverygirl@gmail.com">
            eachandeverygirl@gmail.com
          </a>
           
        </p>
        <p>  </p>
        <p>
          Your data protection rights, described above, are covered by the CCPA,
          short for the California Consumer Privacy Act. To find out more, visit
          the official California Legislative Information website. The CCPA took
          effect on 01/01/2020.  
        </p>
        <p>  </p>
        <p>
          <strong>13</strong> <strong>_Service Providers_</strong> 
        </p>
        <p> </p>
        <p>
          We may employ third party companies and individuals to facilitate our
          Service (“<strong>Service Providers</strong>”), provide Service on our
          behalf, perform Service-related services or assist us in analysing how
          our Service is used. 
        </p>
        <p>  </p>
        <p>
          These third parties have access to your Personal Data only to perform
          these tasks on our behalf and are obligated not to disclose or use it
          for any other purpose. 
        </p>
        <p>  </p>
        <p>
          <strong>14</strong> <strong>_Analytics_</strong> 
        </p>
        <p> </p>
        <p>
          We may use third-party Service Providers to monitor and analyze the
          use of our Service. 
        </p>
        <p>  </p>
        <p>
          <strong>Google Analytics</strong>
        </p>
        <p>
          Google Analytics is a web analytics service offered by Google that
          tracks and reports website traffic. Google uses the data collected to
          track and monitor the use of our Service. This data is shared with
          other Google services. Google may use the collected data to
          contextualise and personalise the ads of its own advertising network. 
        </p>
        <p>  </p>
        <p>
          For more information on the privacy practices of Google, please visit
          the Google Privacy Terms web page:{' '}
          <a href="https://policies.google.com/privacy?hl=en">
            https://policies.google.com/privacy?hl=en
          </a>
           
        </p>
        <p> </p>
        <p>
          We also encourage you to review the Google’s policy for safeguarding
          your data:{' '}
          <a href="https://support.google.com/analytics/answer/6004245">
            https://support.google.com/analytics/answer/6004245
          </a>
          . 
        </p>
        <p>  </p>
        <p>
          <strong>15</strong> <strong>_CI/CD tools_</strong> 
        </p>
        <p>  </p>
        <p>
          We may use third-party Service Providers to automate the development
          process of our Service.  
        </p>
        <p> </p>
        <p>
          <strong>GitHub</strong> 
        </p>
        <p>  </p>
        <p>GitHub is provided by GitHub, Inc. </p>
        <p>  </p>
        <p>
          GitHub is a development platform to host and review code, manage
          projects, and build software. 
        </p>
        <p>  </p>
        <p>
          For more information on what data GitHub collects for what purpose and
          how the protection of the data is ensured, please visit GitHub Privacy
          Policy page:{' '}
          <a href="https://help.github.com/en/articles/github-privacy-statement">
            https://help.github.com/en/articles/github-privacy-statement.
          </a>{' '}
           
        </p>
        <p> </p>
        <p>  </p>
        <p>
          <strong>16</strong> <strong>_Links to Other Sites_</strong> 
        </p>
        <p> </p>
        <p>
          Our Service may contain links to other sites that are not operated by
          us. If you click a third party link, you will be directed to that
          third party’s site. We strongly advise you to review the Privacy
          Policy of every site you visit. 
        </p>
        <p> </p>
        <p>
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services. 
        </p>
        <p>  </p>
        <p>
          <strong>17</strong> <strong>_Children’s Privacy_</strong> 
        </p>
        <p>  </p>
        <p>
          Our Services are not intended for use by children under the age of 13
          (“<strong>Children</strong>”).  
        </p>
        <p>  </p>
        <p>
          We do not knowingly collect personally identifiable information from
          Children under 13. If you become aware that a Child has provided us
          with Personal Data, please contact us. If we become aware that we have
          collected Personal Data from Children without verification of parental
          consent, we take steps to remove that information from our servers. 
        </p>
        <p>  </p>
        <p>
          <strong>18</strong> <strong>_Changes to This Privacy Policy_</strong> 
        </p>
        <p> </p>
        <p>
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page. 
        </p>
        <p> </p>
        <p>
          We will let you know via email and/or a prominent notice on our
          Service, prior to the change becoming effective and update “effective
          date” at the top of this Privacy Policy. 
        </p>
        <p>  </p>
        <p>
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page. 
        </p>
        <p>  </p>
        <p>
          <strong>19</strong> <strong>_Contact Us_</strong> 
        </p>
        <p> </p>
        <p>
          If you have any questions about this Privacy Policy, please contact
          us: 
        </p>
        <p>  </p>
        <p>
          By email:{' '}
          <a href="mailto:eachandeverygirl@gmail.com">
            eachandeverygirl@gmail.com
          </a>
          . 
        </p>
        <p>  </p>
        <p>
          <span class="hashtag">#App/each and every girl#</span>
        </p>
      </Policies>
    </Layout>
  );
}
